// KenBot — floating animated help character (replaces the old AI Help panel).
// Mounted once on first open, then toggled by hiding his container; chat
// history survives hide/show within a session. Help-screen-only per Ken:
// summoned from the game screen's 💬 Ken button, dismissed on exit to menu.

let mounted = null; // Promise<HTMLElement> — the island container, set on first show
let visible = false;

export function toggleKenBot() {
  if (visible) hideKenBot();
  else showKenBot();
}

export function showKenBot() {
  if (!mounted) {
    mounted = import('../kenbot/island.js').then((m) => m.mountKenBot());
  }
  visible = true;
  mounted.then((el) => {
    el.style.display = visible ? '' : 'none';
  });
}

export function hideKenBot() {
  visible = false;
  if (mounted) {
    mounted.then((el) => {
      el.style.display = visible ? '' : 'none';
    });
  }
}
